"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const state_1 = __importDefault(require("../state"));
const drawRectangle_1 = __importDefault(require("./draw/drawRectangle"));
const drawText_1 = __importDefault(require("./draw/drawText"));
const drawCounterHUD = () => {
    const width = 97;
    (0, drawRectangle_1.default)("#000000", .25, 18, 4, width, 11, 10003);
    (0, drawText_1.default)(`Claw ${state_1.default.level.requiredDestructibles - state_1.default.brokenDestructibleIDs.length} objects!`, "#ffffff", 20, 6, 1, gameWidth_1.default, 1, "left", "top");
};
exports.default = drawCounterHUD;
